import React, { useEffect } from "react";
import Sidebar from "./layout/sidebar/Sidebar";
import Navbar from "./layout/header/Navbar";
import { useLocation, Outlet } from "react-router-dom";

const AdminLayout = () => {
  const org = JSON.parse(sessionStorage.getItem('user'));
  const themes = sessionStorage.getItem('account-customization');
  const [isReportEditorRoutes, setIsReportEditorRoutes] = React.useState(false);
  const location = useLocation();

  useEffect(() => {
    if(location.pathname === '/admin/report/create' || location.pathname === '/admin/report/edit') {
      setIsReportEditorRoutes(true);
    } else setIsReportEditorRoutes(false);
  }, [location.pathname]);

  return (
    <div className="flex justify-between overflow-y-hidden">
      { !isReportEditorRoutes &&
        <div className="w-[250px]">
        <Sidebar />
      </div>}
      <div className={`text-gray-900 ${
        isReportEditorRoutes ? 'w-[100%]' : 'w-[calc(100%-250px)]'
      }`}>
        <section 
          className={`h-[calc(100vh)] ${isReportEditorRoutes ? 'px-1' : 'px-5'} pt-2 admin-container-panel overflow-y-auto`}
          style={{
            backgroundColor : themes ? JSON.parse(themes)?.bodyColor :
            org?.orgAppearance?.bodyBackgroundColour || "#F2F4F7"
          }}
        >
          <Navbar />
          <Outlet />
        </section>
      </div>
    </div>
  );
};

export default AdminLayout;
